jQuery(function ($) {
	if (!$.fn || typeof $.fn.slick !== 'function') {
		return;
	}

	$('.card-carousel__track').each(function () {
		var $track = $(this);
		var $module = $track.closest('.card-carousel');
		var $prevArrow = $module.find('.card-carousel__control--prev');
		var $nextArrow = $module.find('.card-carousel__control--next');
		var slideCount = $track.children().length;
		var $controls = $module.find('.card-carousel__controls');
		var hasControls = $prevArrow.length && $nextArrow.length;
		var desktopShowsNav = slideCount > 3;
		var tabletShowsNav = slideCount > 2;
		var mobileShowsNav = slideCount > 1;
		if ($track.hasClass('slick-initialized')) {
			return;
		}

		$track.slick({
			dots: desktopShowsNav,
			arrows: hasControls && desktopShowsNav,
			prevArrow: hasControls ? $prevArrow : undefined,
			nextArrow: hasControls ? $nextArrow : undefined,
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			adaptiveHeight: false,
			responsive: [
				{
					breakpoint: 1201,
					settings: {
						slidesToShow: 2,
						dots: tabletShowsNav,
						arrows: hasControls && tabletShowsNav,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						dots: mobileShowsNav,
						arrows: hasControls && mobileShowsNav,
					}
				}
			]
		});

		function syncControlsVisibility() {
			var slick = $track.slick('getSlick');
			if (!slick || !slick.options || !hasControls) {
				return;
			}

			$controls.toggle(!!slick.options.arrows);
		}

		$track.on('init reInit setPosition breakpoint', syncControlsVisibility);
		syncControlsVisibility();
	});
});
